module.exports = __webpack_public_path__ + "static/media/1_09.e3a41e8a.jpg";